module.exports = __webpack_public_path__ + "static/pic03@2x-2f9333b7615c6244e49948db3e5c1ecd.jpg";